import {
  DPO_STATUS_PENDING,
  DPO_STATUS_PAID,
  DPO_STATUS_RESERVED_CANCELLED,
  DPO_STATUS_FULFILLED,
} from 'shared/constants/orders'

export const ORDER_FILTER_ALL = 'all'
export const ORDER_FILTER_PENDING_PAYMENT = DPO_STATUS_PENDING
export const ORDER_FILTER_PAID = DPO_STATUS_PAID
export const ORDER_FILTER_FULFILLED = DPO_STATUS_FULFILLED
export const ORDER_FILTER_CANCELLED = DPO_STATUS_RESERVED_CANCELLED

export const ORDER_FILTERS = [
  ORDER_FILTER_ALL, ORDER_FILTER_PENDING_PAYMENT, ORDER_FILTER_PAID, ORDER_FILTER_FULFILLED, ORDER_FILTER_CANCELLED,
]

export const ORDER_FILTER_PARAM_REGEX = ORDER_FILTERS.join('|')

export const ORDER_FILTER_MAP = new Map([
  [ORDER_FILTER_ALL, 'All orders'],
  [ORDER_FILTER_PENDING_PAYMENT, 'Unpaid'],
  [ORDER_FILTER_PAID, 'Paid & pending fulfilment'],
  [ORDER_FILTER_FULFILLED, 'Fulfilled'],
  [ORDER_FILTER_CANCELLED, 'Cancelled'],
])
